import { z } from 'zod';

export const formErrorSchema = z.object({
  path: z.array(z.string().or(z.number())),
  type: z.string(),
  message: z.string().optional(),
  context: z.record(z.string(), z.unknown()).optional(),
});

export type FormError = z.infer<typeof formErrorSchema>;
